module.exports = __webpack_public_path__ + "img/Wp_2028.a45f99f8.png";